import { IDeleteGestaoDistribuicaoEpiUseCase } from "../../../presentation/useCases/delete/delete_gestao_distribuicao_epi_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";


export class DeleteGestaoDistribuicaoEpiUseCase implements IDeleteGestaoDistribuicaoEpiUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) { }

  async deleteGestaoDistribuicaoEpi(
    idGestaoDistribuicaoEpi: number,
  ): Promise<void> {
    await this.repository.deleteGestaoDistribuicaoEpi(idGestaoDistribuicaoEpi);
  }
}
